import { useAuth } from 'react-oidc-context';
import { useVigoToast } from 'src/@core/hooks/useVigoToast';
import { ExportModel } from 'src/models/salesorder';
import { useGetUserProfileQuery } from 'src/queries/services/identity';
import { postSalesOrderExportRequest } from 'src/services/salesorder';
import { safeJsonParse } from 'src/@core/utils/safeJsonParse';

const useServerExport = (storageKey: string, filter: string) => {
  const { vigoToast } = useVigoToast({});
  const auth = useAuth();
  const user = auth.user;
  const loggedInUserId = user?.profile.tenantUserId as string;

  const { data: userData } = useGetUserProfileQuery(loggedInUserId);

  const handleExport = (): void => {
    const exportColumns: { [x: string]: string } = {};

    const gridState = safeJsonParse(localStorage.getItem(storageKey));

    if (gridState) {
      gridState?.columns
        ?.filter(
          (column: any) =>
            Object.hasOwn(column, 'name') &&
            Boolean(column?.name) &&
            Object.hasOwn(column, 'visible') &&
            column?.visible
        )
        ?.map((column: any) => column.name)
        .forEach((column: any) => {
          let showme = true;

          if (column === 'actions') {
            showme = false;
          }

          if (showme) {
            exportColumns[column] = column;
          }
        });

      const exportModel: ExportModel = {
        filter: filter,
        showDeleted: false,
        ignoreOwner: false,
        notifyOnCompletion: userData?.userProfile?.email ?? '',
        columns: exportColumns
      };

      // call service
      postSalesOrderExportRequest(exportModel)
        .then(() => {
          vigoToast.success('Export link will be sent to your email shortly.');
        })
        .catch(() => {
          vigoToast.error('There was an error exporting the data.');
        });
    }
  };

  return { handleExport };
};

export default useServerExport;
